import { Drawer, Form, Input, Button } from "antd";
import { useCallback } from "react";
import type { MerchantCabinetCreateType } from "@src/types";
import { useMerchantCabinetCreate } from "@src/queries";

type Props = {
    open: boolean;
    onClose: () => void;
};

export default function MerchantCabinetCreateDrawer({ open, onClose }: Props) {
    const [form] = Form.useForm<MerchantCabinetCreateType>();
    const { mutateAsync, isPending } = useMerchantCabinetCreate();

    const handleFinish = useCallback(
        async (values: MerchantCabinetCreateType) => {
            await mutateAsync(values, {
                onSuccess: () => {
                    form.resetFields();
                    onClose(); // закрываем Drawer только при успехе
                },
            });
        },
        [mutateAsync, form, onClose],
    );

    const handleClose = useCallback(() => {
        if (!isPending) {
            form.resetFields();
            onClose();
        }
    }, [isPending, form, onClose]);

    return (
        <Drawer
            title="Добавить магазин"
            open={open}
            onClose={handleClose}
            destroyOnHidden
            maskClosable={!isPending}
            extra={
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={isPending}
                    onClick={() => form.submit()}
                >
                    Сохранить
                </Button>
            }
        >
            <Form<MerchantCabinetCreateType>
                layout="vertical"
                form={form}
                onFinish={handleFinish}
                requiredMark="optional"
            >
                <Form.Item
                    label="Логин"
                    name="username"
                    rules={[{ required: true, message: "Введите логин кабинета" }]}
                >
                    <Input placeholder="Логин кабинета" autoFocus />
                </Form.Item>

                <Form.Item
                    label="Пароль"
                    name="password"
                    rules={[{ required: true, message: "Введите пароль от кабинета" }]}
                >
                    <Input.Password placeholder="Пароль от кабинета" />
                </Form.Item>
            </Form>
        </Drawer>
    );
}
